(function () {
  'use strict';

  const CONFIG = {
    hplValue: 'HPL',
    masselloValue: 'Legno Massello',
    laminatoValue: 'Laminato',

    // Colori per materiali
    hplColors: ['Nero', 'Silver'],                   // per Katia e Time
    hplColorsKarat: ['Nero', 'Bianco', 'Grigio', 'Silver'], // per Karat
    masselloColors: ['Legno'],
    laminatoColors: ['Verde', 'Bianco', 'Grigio', 'Blu'], // per Katia e Time
    laminatoColorsJulia: ['Verde', 'Bianco', 'Grigio', 'Blu', 'Silver', 'Nero'], // per Julia

    // Identificatori prodotti
    katiaAndTimeProducts: ['katia', 'time'], // Aggiunto 'time' qui
    karatProducts: ['karat']
  };

  // Restituisce true se il prodotto corrente è nella lista
  function productMatchesList(list) {
    const slug = window.location.pathname.toLowerCase();
    return list.some(name => slug.includes(name.toLowerCase()));
  }

  function getFieldset(picker, index) {
    return picker.querySelector(`fieldset[data-fieldset-index="${index}"]`);
  }

  function getInputs(fieldset) {
    if (!fieldset) return [];
    return Array.from(fieldset.querySelectorAll('input[type="radio"]'));
  }

  function getCheckedValue(fieldset) {
    const checked = fieldset?.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function selectInput(input) {
    if (!input || input.checked) return;

    input.checked = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applyValidation(picker) {
    const materialFieldset = getFieldset(picker, 0);
    const colorFieldset = getFieldset(picker, 1);

    if (!materialFieldset || !colorFieldset) return;

    const material = getCheckedValue(materialFieldset);
    const colorInputs = getInputs(colorFieldset);

    if (!material || colorInputs.length === 0) return;

    let allowed = [];

    const isKatiaOrTime = productMatchesList(CONFIG.katiaAndTimeProducts);
    const isKarat = productMatchesList(CONFIG.karatProducts);

    if (isKarat) {
      // 1. Caso Karat
      if (material === CONFIG.hplValue) {
        allowed = CONFIG.hplColorsKarat;
      } else if (material === CONFIG.masselloValue) {
        allowed = CONFIG.masselloColors;
      }
      // Niente laminato per Karat, quindi array 'allowed' resta vuoto
    } else if (isKatiaOrTime) {
      // 2. Caso Katia / Time
      if (material === CONFIG.hplValue) {
        allowed = CONFIG.hplColors;
      } else if (material === CONFIG.masselloValue) {
        allowed = CONFIG.masselloColors;
      } else if (material === CONFIG.laminatoValue) {
        allowed = CONFIG.laminatoColors;
      }
    } else {
      // 3. Caso Julia (Default)
      if (material === CONFIG.masselloValue) {
        allowed = CONFIG.masselloColors;
      } else if (material === CONFIG.laminatoValue) {
        allowed = CONFIG.laminatoColorsJulia;
      }
    }

    let firstValid = null;
    let selectedStillValid = false;

    colorInputs.forEach((input) => {
      const isValid = allowed.includes(input.value);

      // 🚀 SOLO DISABLE/ENABLE (NO VISIBILITY MANIPULATION)
      input.disabled = !isValid;

      if (isValid) {
        if (!firstValid) firstValid = input;
        if (input.checked) selectedStillValid = true;
      } else {
        input.checked = false;
      }
    });

    // se selezione non valida → fallback
    if (!selectedStillValid && firstValid) {
      selectInput(firstValid);
    }
  }

  function bindPicker(picker) {
    if (picker.dataset.bbtoolsBound === 'true') return;
    picker.dataset.bbtoolsBound = 'true';

    let scheduled = false;

    function schedule() {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        applyValidation(picker);
      });
    }

    picker.addEventListener('change', (event) => {
      const target = event.target;

      const isRelevant =
        target.matches('fieldset[data-fieldset-index="0"] input[type="radio"]') ||
        target.matches('fieldset[data-fieldset-index="1"] input[type="radio"]');

      if (!isRelevant) return;

      schedule();
    });

    // init
    schedule();
  }

  function init() {
    document.querySelectorAll('variant-picker').forEach(bindPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();